export enum TiposMutationLoading {
    SET_SHOW = 'setShow',
}
